import { createFileRoute } from "@tanstack/react-router"
import { LogPage } from "./-components/LogPage"

export const Route = createFileRoute("/app/admin-settings/logging/$id")({
  beforeLoad: () => ({
    getTitle: () => "Log",
  }),
  component: LogPage,
})
